import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "../../../components/GlobalSnackbar/snackbarStore";
import { apiClient } from "@copro/api";
import { keys } from "./keys";

async function deleteSubTopic(id: string) {
  const { error } = await apiClient
    .from('sub_topics')
    .delete()
    .eq('id', id)

  if (error) {
    throw error
  }
}

export function useDeleteSubTopic() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (subTopicId: string) => deleteSubTopic(subTopicId),
    onSuccess: () => {
      enqueueSnackbar('Sous-sujet supprimé.', 'success');

      queryClient.invalidateQueries({ queryKey: keys.lists() })
    }
  })
}
